"use client";

import { useLanguage } from "@/i18n/LanguageContext";

const scenariosEn = [
  {
    title: "Long-term Family Home (15+ years)",
    rec: "Impact Windows",
    recColor: "bg-[#047857] text-white",
    desc: "Improves home resale value. Insurance savings and zero shutter maintenance add up over time.",
  },
  {
    title: "Investment Rental",
    rec: "Mixed",
    recColor: "bg-[#fbbf24] text-[#064e3b]",
    desc: "Shutters for non-corridor units with low storm exposure. Impact windows for waterfront or ground-floor units where tenant safety and code compliance matter more.",
  },
  {
    title: "Snowbird Second Home",
    rec: "Impact Windows",
    recColor: "bg-[#047857] text-white",
    desc: "Improves home resale value. No risk of forgetting to deploy shutters before a storm while you are out of state.",
  },
];

const scenariosEs = [
  {
    title: "Casa Familiar a Largo Plazo (15+ años)",
    rec: "Ventanas de Impacto",
    recColor: "bg-[#047857] text-white",
    desc: "Mejora el valor de reventa de la vivienda. Los ahorros de seguro y cero mantenimiento de persianas se acumulan con el tiempo.",
  },
  {
    title: "Alquiler de Inversión",
    rec: "Mixto",
    recColor: "bg-[#fbbf24] text-[#064e3b]",
    desc: "Persianas para unidades no costeras con baja exposición a tormentas. Ventanas de impacto para unidades frente al agua o planta baja donde la seguridad del inquilino y el cumplimiento del código son más importantes.",
  },
  {
    title: "Segunda Casa para Temporada",
    rec: "Ventanas de Impacto",
    recColor: "bg-[#047857] text-white",
    desc: "Mejora el valor de reventa de la vivienda. Sin riesgo de olvidar desplegar persianas antes de una tormenta mientras está fuera del estado.",
  },
];

export default function ScenarioCards() {
  const { currentLang, t } = useLanguage();
  const isEs = currentLang === "es";
  const scenarios = isEs ? scenariosEs : scenariosEn;

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-[#064e3b] mb-6">
        {t("blog.shutters.scenarioHeading")}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {scenarios.map((s) => (
          <div
            key={s.title}
            className="bg-white rounded-xl border border-[#064e3b]/10 p-6 shadow-sm hover:shadow-lg transition"
          >
            <span className={`inline-block text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3 ${s.recColor}`}>
              {s.rec}
            </span>
            <h3 className="font-bold text-[#064e3b] text-lg leading-snug">{s.title}</h3>
            <p className="text-sm text-gray-600 mt-3 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}